// extracted by mini-css-extract-plugin
export var animationContainer = "_c5-0";
export var asteriskIcon = "_c5-8";
export var conversationLeftSection = "_c5-4";
export var conversationListItem = "_c5-3";
export var conversationMiddleSection = "_c5-5";
export var conversationRightSection = "_c5-6";
export var detailsContent = "_c5-1";
export var listContainer = "_c5-7";
export var modalContent = "_c5-2";